import { memo } from "react";
import * as Styled from "./style";
export const CategoryCarouselSkeleton = memo(() => (
  <Styled.DivCategoryCarouselWrapper>
    <Styled.CategoryCarouselSkeleton type="square" animType="fade" width="100%" borderRadius={8} />
  </Styled.DivCategoryCarouselWrapper>
));
CategoryCarouselSkeleton.displayName = "CategoryCarouselSkeleton";
